import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import DrawingContainer from '../components/DrawingContainer';
import { parseOpenAngle } from '../open-angle';

const Viewer: React.FC = () => {
  const { uuid = '' } = useParams<{ uuid: string }>();
  const [params] = useSearchParams();

  return (
    <>
      <DrawingContainer uuid={uuid} openAngle={parseOpenAngle(params)} />
    </>
  );
};

export default Viewer;
